export const setLoginToken = token => {
    sessionStorage.setItem("token", token);
};

export const getLoginToken = () => {
    const token = sessionStorage.getItem("token");
    return token;
};

export const clearLoginToken = () => {
    sessionStorage.removeItem("token");
};



// WEBPACK FOOTER //
// ./src/helpers/sessionHandler.js